import { render, staticRenderFns } from "./AddCampaignForm.vue?vue&type=template&id=2a720454"
import script from "./AddCampaignForm.vue?vue&type=script&lang=js"
export * from "./AddCampaignForm.vue?vue&type=script&lang=js"
import style0 from "./AddCampaignForm.vue?vue&type=style&index=0&id=2a720454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports